import Image from "next/image";
import React from "react";

const AcceptedCollaterals = ({ data }) => {
  const { sectionTitle, benefits } = data;

  return (
    <section className="bg-[#F9F9FB] border-dashed border-t-2 border-b-2 border-borderColor py-16">
      <div className="container px-3 xm:px-2">
        <h3 className="text-center text-base2 font-medium text-baseBlack mb-5 sm:text-lg">
          {sectionTitle}
        </h3>
        <div className="flex flex-wrap justify-between gap-1">
          {benefits.map((item) => (
            <div
              key={item.id}
              className="flex items-center sm:items-start sm:flex-col gap-2 sm:w-[48%] w-[18%] sm:gap-1"
            >
              <Image src={item.icon} alt={item.text} width={50} height={50}  className="w-auto h-auto"/>
              {/* Text */}
              <p className="text-[#1A1A1A] text-sm sm:text-base">{item.text}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AcceptedCollaterals;
